module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/buying-large-ce5f71a1c45496c3bd201a6221083f68.svg";